export enum AlertTypes {
    SUCCESS = "success",
    FAILURE = "danger",
    WARNING = "warning"
}